export default __webpack_public_path__ + "static/media/oscer-pres-tremor.d4cb7742.svg";